import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import type { Me } from '@/composables/useClient';

export const useAuthStore = defineStore('useAuthStore', () => {
  const me = ref<Me>();
  const isAuthenticated = computed(() => !!me.value);
  const csrfToken = ref<string>();
  const initialized = ref(false);
  const onboardingPrompted = ref(false);

  return { me, isAuthenticated, csrfToken, initialized, onboardingPrompted };
});
